<div *ngIf="warranty$ | async as warranty" class="flex flex-col gap-6">
  <div>
    <div class="mb-3">
      <h1 class="mr-2 inline-block text-3xl text-base-dark font-bold">Hi {{ warranty.customer?.name || '' }},</h1>
      <h3 class="inline-block text-xl italic text-gray-600 font-bold">how can we help you today?</h3>
    </div>
    <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4">
      <ws-warranty-picker
        [customerId]="warranty.customerId"
        [contractNumber]="warranty.contractNumber"
      ></ws-warranty-picker>

      <div *ngIf="warranty.distributor as distributor" class="flex items-center gap-3 min-w-0">
        <img
          *ngIf="distributor.logo as logo"
          [src]="logo"
          alt="Program logo"
          class="h-10 max-w-[120px] object-contain shrink-0"
        />

        <span class="text-base font-medium text-gray-700 truncate min-w-0">
          {{ distributor.programName || distributor.name }}
        </span>
      </div>
    </div>
  </div>
  <ws-warranty-details-card [warranty]="warranty || undefined" (renewed)="onRenewed($event)"></ws-warranty-details-card>
  <ws-warranty-claims-card [warranty]="warranty || undefined"></ws-warranty-claims-card>
  <ws-warranty-documents-card [warranty]="warranty || undefined"></ws-warranty-documents-card>
  <ws-warranty-document-repository [warranty]="warranty"></ws-warranty-document-repository>
</div>
